import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../../app/i18n";
import { LeadDetailPage } from "../../../../areas/seller/leads/LeadDetailPage";

/** FE-18 dossier detail. */
export const Route = createFileRoute("/app/_seller/leads/$leadId")({
  beforeLoad: () => loadNamespaces("leads"),
  component: LeadDetailPage,
});
